/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { DataChartBarsAUpIcon16Light } from './DataChartBarsAUpIcon16Light';
import { DataChartBarsAUpIcon16Regular } from './DataChartBarsAUpIcon16Regular';
import { DataChartBarsAUpIcon16Solid } from './DataChartBarsAUpIcon16Solid';
import { DataChartBarsAUpIcon20Light } from './DataChartBarsAUpIcon20Light';
import { DataChartBarsAUpIcon20Regular } from './DataChartBarsAUpIcon20Regular';
import { DataChartBarsAUpIcon20Solid } from './DataChartBarsAUpIcon20Solid';
import { DataChartBarsAUpIcon24Regular } from './DataChartBarsAUpIcon24Regular';
import { DataChartBarsAUpIcon24Solid } from './DataChartBarsAUpIcon24Solid';
import { DataChartBarsAUpIcon32Regular } from './DataChartBarsAUpIcon32Regular';
import { DataChartBarsAUpIcon64Regular } from './DataChartBarsAUpIcon64Regular';
var sizes = {
    16: {
        light: DataChartBarsAUpIcon16Light,
        regular: DataChartBarsAUpIcon16Regular,
        solid: DataChartBarsAUpIcon16Solid,
    },
    20: {
        light: DataChartBarsAUpIcon20Light,
        regular: DataChartBarsAUpIcon20Regular,
        solid: DataChartBarsAUpIcon20Solid,
    },
    24: {
        regular: DataChartBarsAUpIcon24Regular,
        solid: DataChartBarsAUpIcon24Solid,
    },
    32: {
        regular: DataChartBarsAUpIcon32Regular,
    },
    64: {
        regular: DataChartBarsAUpIcon64Regular,
    },
};
export var DataChartBarsAUpIcon = forwardRef('DataChartBarsAUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
